var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9249_5389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: -1,
    width: 10,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.205 1.70815C12.5951 1.31724 12.5952 0.683335 12.2052 0.292276C11.8152 -0.098783 11.1828 -0.0989057 10.7927 0.292002L3.90979 7.18843C3.86872 7.21855 3.82942 7.25221 3.79232 7.28941C3.41118 7.6715 3.40279 8.28529 3.76691 8.67759C3.77785 8.68969 3.78915 8.70158 3.80079 8.71325C3.80895 8.72143 3.81721 8.72944 3.82558 8.73728L10.7926 15.7081C11.183 16.0987 11.8157 16.0984 12.2057 15.7074C12.5958 15.3164 12.5955 14.6827 12.205 14.2921L5.92091 8.00456L12.205 1.70815Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9249_5389)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftFilled);
export default __webpack_public_path__ + "static/media/chevron-left-filled.849748c222c2abf85d53b39974dc6019.svg";
export { ForwardRef as ReactComponent };